module.exports = __webpack_public_path__ + "static/media/01A.dc59440e.png";